<template>
  <video :src="videoPath" controls="controls" style="width: 100%; height: 100%">
    您的浏览器不支持视频播放
  </video>
</template>


<script>
  export default {
    name: "eleSingleVideo",
    props: {
      componentData: {
        type: String
      }
    },
    created() {
      if (this.componentData) {
        this.videoPath = JSON.parse(this.componentData).path;
      }
    },
    data() {
      return {
        videoPath: ""
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/lib/showMoudle/eleSingleVideo.vue